/* global __SERVER__ */

import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { func } from 'prop-types';
import { Route } from 'react-router-dom';

import { NotFound as NotFoundComponent } from '@snapask/common-components';

import MainLayout from '@dragonfruit/layouts/MainLayout';
import SEOHead from '@dragonfruit/components/SEOHead';

class NotFound extends Component {
  static propTypes = {
    t: func.isRequired,
  };

  render() {
    const { t } = this.props;

    return (
      <Route
        render={({ staticContext }) => {
          if (staticContext) {
            staticContext.status = 404; // eslint-disable-line no-param-reassign
          }

          const seoComponent = (
            <SEOHead
              title={t('seo:seo.notFound.title')}
              description={t('seo:seo.notFound.description')}
              robots="noindex, nofollow"
            />
          );

          if (__SERVER__) {
            return seoComponent;
          }

          return (
            <MainLayout>
              {seoComponent}
              <NotFoundComponent
                description={t('error.404.description')}
                title={t('error.404.title')}
              />
            </MainLayout>
          );
        }}
      />
    );
  }
}

export default translate(['error', 'seo'])(NotFound);



// WEBPACK FOOTER //
// ./app/containers/NotFound/NotFound.jsx